import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { agentSearch, setCurrentAgent } from '@redux/modules/agent';
import { getSearchAgentResults } from '@redux/selectors/AgentSelector';
import { getAuditLog } from '@redux/modules/audit';
import { loadFormDefinition } from '@redux/modules/formGeneration';

import Swal from 'sweetalert2/src/sweetalert2';
import AgentAdvancedSearch from '@components/form/forms/AgentAdvancedSearch';
import AgentsTable from '@components/table/AgentsTable';
import Button from '@components/smartAdminUI/Button';
import Panel from '@components/smartAdminUI/Panel';
import { isNull } from 'lodash';

const SearchAgentPage = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const searchResults = useSelector(getSearchAgentResults);

  const agentSelected = row => {
    const jsonBody = {
      action: 'select',
      where: {
        clause: [
          {
            name: 'UniqueID',
            value: row.UniqueID,
          },
        ],
      },
    };

    dispatch(setCurrentAgent(jsonBody));
  };

  const auditClicked = row => {
    Swal.fire({
      allowEnterKey: false,
      allowEscapeKey: false,
      allowOutsideClick: false,
      position: 'center',
      html: 'Loading Agent Audit Log...',
      title: '<span class="fa-stack fa-2x text-secondary m-3"><i class="fal fa-circle-notch fa-spin fa-stack-2x"></i><i class="fas fa-history fa-stack-1x"></i></span>',
      showConfirmButton: false,
      timer: 2000,
    });
    dispatch(getAuditLog({ tableName: 'Agent', uniqueID: row.UniqueID, entityID: row.MemberMlsId }));
    history.push('/audit');
  };

  const onSubmitClicked = jsonBody => {
    dispatch(agentSearch(jsonBody));
  };

  return (
    <>
      <div className="subheader">
        <h1 className="subheader-title">
          <i className="subheader-icon fal fa-search mr-2" />
          Search
          <span className="fw-300 ml-2 mr-2">Agent</span>
        </h1>
      </div>
      <div className="row">
        <div className="col-xl-12">
          <Panel
            header="Search Criteria"
            customClass="searchCriteria"
            panelToolbar={(
              <Button name="btnCreateAgent" variant="primary btn-sm" onClick={() => dispatch(loadFormDefinition('create', 'agent', null, null, 'agentACL'))}>
                <i className="fas fa-plus mr-2" aria-hidden="true" />
                Create Agent
              </Button>
            )}
          >
            <AgentAdvancedSearch
              onSubmitClicked={onSubmitClicked}
            />
          </Panel>
        </div>
        {!isNull(searchResults) && (
          <div className="col-xl-12">
            <Panel header="Search Results" customClass="searchResults">
              <AgentsTable
                displayData={searchResults}
                onAgentSelect={agentSelected}
                onAuditClick={auditClicked}
              />
            </Panel>
          </div>
        )}
      </div>
    </>
  );
};

export default SearchAgentPage;
